<template>
  <div>
    <DxForm
      label-mode="static"
      label-location="top"
    >
      <DxGroupItem
        css-class="content-devx"
        :caption="$t('registerProject.registerProjectGreenHouse.title_groupItem_floor')"
        :col-count="2"
      >
        <DxSimpleItem
          :key="`texture_${keyTexture}`"
          name="textura"
          :data-field="$t('registerProject.registerProjectOpenAir.register_project_textura')"
          editor-type="dxSelectBox"
          :editor-options="{
            items: itemsTextures,
            value: newProject.ground ? newProject.ground.texture : null,
            displayExpr: 'name',
            valueExpr: 'id',
            searchEnabled: devicePlatform === 'web',
            onValueChanged: onChangeTexture,
            placeholder: '',
            readOnly: readOnly
          }"
        />
        <DxSimpleItem
          name="size"
          :data-field="$t('registerProject.registerProjectOpenAir.register_project_Depth')"
          editor-type="dxNumberBox"
          :editor-options="{
            value: newProject.ground ? newProject.ground.depth : null,
            onValueChanged: onChangeSizeDeep,
            readOnly: readOnly
          }"
        />
        <DxSimpleItem
          name="initialNitrogen"
          :data-field="
            $t('registerProject.registerProjectOpenAir.register_project_initial_nitrogen')"
          editor-type="dxNumberBox"
          :editor-options="{
            value: newProject.ground ? newProject.ground.initialNitrogen : null,
            onValueChanged: onChangeInitialNitrogen,
            readOnly: readOnly
          }"
        />
        <DxSimpleItem
          name="initialOrganicMatter"
          :data-field="
            $t('registerProject.registerProjectOpenAir.register_project_initial_organic_matter')"
          editor-type="dxNumberBox"
          :editor-options="{
            value: newProject.ground ?newProject.ground.initial_organic : null,
            onValueChanged: onChangeInitialOrganicMatter,
            readOnly: readOnly
          }"
        />
        <DxSimpleItem
          name="initialWaterContent"
          editor-type="dxNumberBox"
          :data-field="
            $t('registerProject.registerProjectOpenAir.register_project_initial_water_content')"
          :editor-options="{
            value: newProject.ground ? newProject.ground.initial_water : null,
            onValueChanged: onChangeInitialWater,
            readOnly: readOnly,
            hint: 'Valor correspondiente a la textura seleccionada a capacidad de campo. ' +
              'Editar si se dispone de un valor medido.'
          }"
        />
        <template>
          <DxItem>
            <template
              #default
            >
              <div style="padding-top: 1rem;">
                <span style="color: steelblue;">
                  Valor correspondiente a la textura seleccionada a capacidad de campo.
                  <br>
                  Editar si se dispone de un valor medido.
                </span>
              </div>
            </template>
          </DxItem>
        </template>
      </DxGroupItem>
      <DxGroupItem
        css-class="content-devx"
        :caption="$t('registerProject.registerProjectOpenAir.title_groupItem_manure_application')"
        :col-count="2"
      >
        <DxSimpleItem
          :key="`manure_${keyManure}`"
          name="manure"
          :data-field="$t('registerProject.registerProjectOpenAir.register_project_manure')"
          editor-type="dxSelectBox"
          :editor-options="{
            items: manure,
            displayExpr: 'name',
            valueExpr: 'id',
            value: newProject.manure ? newProject.manure.manure_id : null,
            onValueChanged: onChangeManure,
            placeholder: '',
            readOnly: readOnly
          }"
        />
        <DxSimpleItem
          name="aplicationDate"
          :data-field="$t('registerProject.registerProjectOpenAir.register_project_aplicationDate')"
          editor-type="dxDateBox"
          :editor-options="{
            value: newProject.manure ? newProject.manure.date : null,
            displayFormat: 'dd/MM/yyyy',
            onValueChanged: onChangeApplicationDateManure,
            max: newProject.cultive.date_init,
            readOnly: readOnly
          }"
        />

        <DxSimpleItem
          name="appliedVolumen"
          :data-field="$t('registerProject.registerProjectOpenAir.register_project_appliedVolumen')"
          editor-type="dxNumberBox"
          :editor-options="{
            value: newProject.manure ?newProject.manure.volume : null,
            onValueChanged: onChangeVolApplied,
            readOnly: readOnly,
          }"
        />
      </DxGroupItem>
      <DxGroupItem
        css-class="content-devx"
        :caption="
          $t('registerProject.registerProjectOpenAir.title_groupItem_fertilizer_application')"
        :col-count="2"
      >
        <DxSimpleItem
          name="appliedVolumen"
          :data-field="$t('registerProject.registerProjectOpenAir.register_project_phosphorus')"
          editor-type="dxNumberBox"
          :editor-options="{
            value: newProject.ground ? newProject.ground.P_contributed : null,
            onValueChanged: onChangeP_contributed,
            readOnly: readOnly
          }"
        />
        <DxSimpleItem
          name="appliedVolumen"
          :data-field="$t('registerProject.registerProjectOpenAir.register_project_potassium')"
          editor-type="dxNumberBox"
          :editor-options="{
            value: newProject.ground ? newProject.ground.K_contributed : null,
            onValueChanged: onChangeK_contributed,
            readOnly: readOnly
          }"
        />
        <DxSimpleItem
          :key="`fertilizers_${keyFertilizers}`"
          name=""
          data-field="Tipo de fertilizante nitrogenado"
          editor-type="dxSelectBox"
          :editor-options="{
            items: fullListFertilizers,
            value: newProject.ground ? newProject.ground.fertilizer : null,
            displayExpr: 'nameMedio',
            valueExpr: 'id',
            searchEnabled: true,
            onValueChanged: onChangeFertilizerType,
            placeholder: '',
            readOnly: readOnly
          }"
        />
      </DxGroupItem>
    </DxForm>

    <DxPopUpTexture v-if="selection !== 'GreenHouse'" />
    <DxPopUpManure v-if="selection !== 'GreenHouse'" />
    <DxPopUpFertilizers />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxItem,
} from 'devextreme-vue/form';
import DxPopUpTexture from '../popUpTexture/index.vue';
import DxPopUpManure from '../../registerProjectGreenhouse/PopUpManure/index.vue';
import EventBus from '../../../../js/event-bus';
import { DEVICE_PLATFORM } from '../../../../js/constants';
import DxPopUpFertilizers from '../../registerProjectGreenhouse/PopUpFertilizers/index.vue';

export default {
  name: 'OpenAirPartTwo',
  components: {
    DxForm,
    DxGroupItem,
    DxSimpleItem,
    DxPopUpTexture,
    DxPopUpManure,
    DxItem,
    DxPopUpFertilizers,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      itemsTextures: [],
      keyTexture: 0,
      keyManure: 0,
      devicePlatform: DEVICE_PLATFORM,
      fertilizer: null,
      keyFertilizers: 0,
      fullListFertilizers: [],
    };
  },
  computed: {
    ...mapState('authentication', ['selection']),
    ...mapState('ProjectGreenHouse', ['manure', 'textures', 'typesFloor']),
    ...mapState('ProjectOpenAir', ['newProject', 'itemsTexture']),
    ...mapState('Database', [
      'listFertilizers',
    ]),
  },
  async beforeMount() {
    try {
      EventBus.$on('create-database-texture', (data) => {
        if (data) {
          this.itemsTextures = this.textures.concat(this.typesFloor);
        }
      });
      EventBus.$on('selected-texture', (id) => {
        if (id) {
          this.setChangeTexture(id);
          this.keyTexture += 1;
        }
      });
      EventBus.$on('selected-manure', (id) => {
        if (id) {
          this.setManureSelected(id);
          this.keyManure += 1;
        }
      });
      EventBus.$on('setTypesFloor', this.setTypesFloor);
      await this.fetchDatabaseTexture();
      this.itemsTextures = this.textures.concat(this.typesFloor);
      EventBus.$on('selected-fertilizer', (item) => {
        if (item) {
          this.fullListFertilizers.push(
            {
              ...item,
              nameMedio: `${item.name} (${item.n}%)`,
            },
          );
          this.fertilizer = item.id;
          this.setFertilizer(item.id);
          this.keyFertilizers += 1;
        }
      });
    } catch (error) {
      this.$f7.dialog.alert(this.$t(`${error}`));
    } finally {
      this.$f7.preloader.hide();
    }
  },
  beforeDestroy() {
    EventBus.$off('create-database-texture');
    EventBus.$off('selected-texture');
    EventBus.$off('selected-manure');
    EventBus.$off('setTypesFloor');
    EventBus.$off('selected-fertilizer');
  },
  async mounted() {
    if (!this.newProject.ground && this.newProject.ground_external) {
      this.newProject.ground = this.newProject.ground_external;
    }
    if (this.newProject.ground_external && this.newProject.ground_external.texture_id) {
      this.newProject.ground.texture = this.newProject.ground_external.texture_id;
    }
    if (this.newProject.ground_external && this.newProject.ground_external.root_deep) {
      this.newProject.ground.depth = this.newProject.ground_external.root_deep;
    }
    if (this.newProject.ground_external && this.newProject.ground_external.initial_nitrogen) {
      this.newProject.ground.initialNitrogen = this.newProject.ground_external.initial_nitrogen;
    }
    if (this.newProject.ground_external && this.newProject.ground_external.initial_organic) {
      this.newProject.ground.initial_organic = this.newProject.ground_external.initial_organic;
    }
    if (this.newProject.ground_external && this.newProject.ground_external.initial_water) {
      this.newProject.ground.initial_water = this.newProject.ground_external.initial_water;
    }
    if (this.newProject.ground_external && this.newProject.ground_external.P_contributed) {
      this.newProject.ground.P_contributed = this.newProject.ground_external.P_contributed;
    }
    if (this.newProject.ground_external && this.newProject.ground_external.K_contributed) {
      this.newProject.ground.K_contributed = this.newProject.ground_external.K_contributed;
    }
    if (this.newProject.ground_external && this.newProject.ground_external.fertilizer) {
      this.newProject.ground.fertilizer = this.newProject.ground_external.fertilizer;
    }
    if (this.newProject.cultive && this.newProject.cultive.density) {
      this.newProject.cultive.density_plantation = this.newProject.cultive.density;
    }
    if (!this.newProject.manure) {
      this.newProject.manure = {
        manure_id: '',
        manure_name: '',
        date: '',
        volume: 0,
      };
    }

    try {
      this.$f7.preloader.show();

      await this.fetchDatabaseTexture();
      this.itemsTextures = this.textures.concat(this.typesFloor);

      await this.fetchListFertilizers();
      this.fullListFertilizers = [{ nameMedio: 'Añadir', id: 'Añadir' }, ...this.listFertilizers];
    } catch (e) {
      const message = this.$helpers.getFilteredErrorMessage(e);
      if (message.includes('default_') && !message.includes('404')) {
        this.$f7.dialog.alert(message.split('_').pop());
      } else if (!message.includes('404')) {
        this.$f7.dialog.alert(this.$t(message));
      }
    } finally {
      this.$f7.preloader.hide();
    }
  },
  methods: {
    onChangeTexture(e) {
      if (e.value === 'Añadir') {
        this.setEnabledPopUpTexture(true);
        this.setChangeTexture(null);
        this.keyTexture += 1;
      } else {
        this.setChangeTexture(e.value);
        if (e.value) {
          const selectedTexture = this.itemsTextures.find((item) => item.id === e.value);
          if (selectedTexture && selectedTexture.water_content) {
            this.setInitialWater(selectedTexture.water_content);
          }
        }
      }
    },
    onChangeSizeDeep(e) {
      this.setSizeGreenHouse(e.value);
    },
    onChangeInitialNitrogen(e) {
      this.setInitialNitrogen(e.value);
    },
    onChangeInitialOrganicMatter(e) {
      this.setInitialOrganicMatter(e.value);
    },
    onChangeInitialWater(e) {
      this.setInitialWater(e.value);
    },
    onChangeManure(e) {
      if (e.value === 1) {
        this.setEnabledPopUpManure(true);
        this.setManureSelected(null);
        this.keyManure += 1;
      } else {
        this.setManureSelected(e.value);
      }
    },
    onChangeApplicationDateManure(e) {
      this.setApplicationDateManure(e.value);
    },
    onChangeVolApplied(e) {
      this.setVolApplied(e.value);
    },
    onChangeP_contributed(e) {
      this.setPContributed(e.value);
    },
    onChangeK_contributed(e) {
      this.setKContributed(e.value);
    },
    setTypesFloor() {
      this.itemsTextures = this.textures.concat(this.typesFloor);
      this.keyTexture += 1;
    },

    onChangeFertilizerType(e) {
      if (e.value === 'Añadir') {
        this.setEnabledPopUpFertilizers(true);
        this.fertilizer = null;
        this.keyFertilizers += 1;
      } else {
        this.fertilizer = e.value;
        this.setFertilizer(e.value);
      }
    },
    ...mapActions('ProjectGreenHouse', ['setEnabledPopUpManure', 'fetchDatabaseTexture']),
    ...mapActions('ProjectOpenAir', ['setNameProject', 'setSizeGreenHouse', 'setProvince', 'setStation', 'setCrop',
      'setPContributed', 'setKContributed', 'setApplicationDateManure', 'setVolApplied', 'setInitialOrganicMatter',
      'setDateEndCrop', 'setEnabledPopUpTexture', 'setChangeTexture', 'setInitialNitrogen', 'setManureSelected',
      'setInitialWater', 'setEnabledPopUpFertilizers', 'setFertilizer']),
    ...mapActions('Database', ['fetchListFertilizers']),
  },
};
</script>

<style>
</style>
